<template>
    <div class="header_wrap">
        <div class="clear header">
            <div class="logo fl">
                <img src="@/assets/logo.png" alt="">
            </div>
            <!-- <div class="win-win fl">
                <img src="@/assets/logo.png" alt="">
                <img src="@/assets/logo.png" alt="">
                <p>Win-Win</p>
            </div> -->
            <div class="nav fl">
                <a :class="{'active':$route.path=='/'}" @click.prevent="$router.push({path:'/'})">首页</a>
                <a :class="{'active':$route.path=='/about'}" @click.prevent="$router.push({path:'/about'})">关于我们</a>
                <a :class="{'active':$route.path=='/connect'}" @click.prevent="$router.push({path:'/connect'})">联系我们</a>
            </div>
            <!-- <div class="connet fr">
                <img src="@/assets/wechat.png" alt="">
                <img src="@/assets/tx.png" alt="">
            </div> -->
        </div>
    </div>
</template>
<script>
export default {
    name:'Header',
}
</script>
<style scoped lang="less">
    .header_wrap {
        position: absolute;
        width: 100%;
        z-index:9;
        padding:80px 0 0;
        .header{
            padding:0 7.6% 0;
        }
        .logo{
            height:48px;
        }
        .logo img{
            width:100%;
            height:100%;
        }
        .nav{
            line-height: 48px;
            margin-left: 130px;
        }
        .nav a{
            font-size: 16px;
            color: #FFFFFF;
            letter-spacing: 0.46px;
            opacity: .7;
            margin-right: 80px;
        }
        .nav a:hover{
            opacity: 1;
        }
        .nav .active{
            opacity: 1;
        }
        .connet{
            height: 48px;
            line-height: 48px;
        }
        .connet img{
            vertical-align: middle;
            width:32px;
            height:32px;
            border-radius: 50%;
        }
    }
    
</style>


// WEBPACK FOOTER //
// src/layout/header.vue